import { render, staticRenderFns } from "./myBase.vue?vue&type=template&id=3353821c&scoped=true&lang=html&"
import script from "./myBase.vue?vue&type=script&lang=js&"
export * from "./myBase.vue?vue&type=script&lang=js&"
import style0 from "./myBase.vue?vue&type=style&index=0&id=3353821c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3353821c",
  null
  
)

export default component.exports